import React,{ PureComponent, } from 'react'
import {Image, } from 'antd';
import PropTypes from 'prop-types';
import "./Index.less";
import Lang from "@/components/Lang/Lang";

const ImagePreviewGroup= Image.PreviewGroup;
/**
 * 图片预览组件 点击打开，幻灯片模式，
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 * UI样例 : https://oss.essaone.com/9707bd56-26b6-4dfc-aeb4-105635d7bd48.png
 *
 **/
class PicturePreview extends PureComponent {
    static propTypes = {
        list: PropTypes.array.isRequired,
        // title: PropTypes.any.isRequired,
        size: PropTypes.number,
        styleName:PropTypes.string,
        expand: PropTypes.bool.isRequired, //默认展开
    }
    static defaultProps = {
        list: [],
        size: 60,
        styleName:'',
        expand: true,
        moreNum : 6, //第6个 显示更多
    };
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            expandPage:false
        }
    }
    /***
     * 渲染图片 超过六张最后一个放更多
     * */
    getList(list=[],size){
        const {moreNum} = this.props;
        const iLen = list.length||0;
        let childred = [];
        for(let i=0;i<iLen;i++){
            const item = list[i];
            if(iLen<=moreNum){ //数量不超过moreNum ||6的直接输出
                childred.push(<div key={i} className={'pic'} style={{ width:size+'px', height:size+'px'}} onClick={() => this.setVisible(true,i)}>
                    {/*<img src={item.fileUrl} style={{ width:size+'px', height:size+'px'}} />*/}
                    {/*<Image src={item.fileUrl} width={size} height={size} preview={{onVisibleChange: vis => this.setVisible(true,i) }} />*/}
                    <Image src={item.fileUrl+'@!200'} width={size} height={size} preview={false} />
                </div>)
            }else if(i==moreNum-1){//第6个 显示更多
                childred.push(<div key={i} className={'pic more'} style={{ width:size+'px', height:size+'px'}} onClick={() => this.setVisible(true,i)}>
                    <div className={'moreMask'}>
                        <p>+ {iLen-moreNum}</p>
                        {/*<p>{Lang({id: 'GengDuo', default: '更多'})}</p>*/}
                    </div>
                    <img src={item.fileUrl+'@!200'} style={{ width:size+'px', height:size+'px'}} />
                </div>)
            }else if(i>moreNum-1){//超过退出循环
                return childred;
            }else {
                    childred.push(<div key={i} className={'pic'} style={{ width:size+'px', height:size+'px'}} onClick={() => this.setVisible(true,i)}>
                        {/*<img src={item.fileUrl} style={{ width:size+'px', height:size+'px'}} />*/}
                        <Image src={item.fileUrl+'@!200'} width={size} height={size} preview={false} />
                </div>);
            }
        }
        return childred;
    }
    /**
     * 设置 预览
     */
    setVisible(flag,current){
            this.setState({
                visible:flag,
                current:current
            })
    }
    setExpand(flag){
        this.setState({
            expandPage:flag,
        })
    }
    componentWillMount() {
        this.setState({
            expandPage:this.props.expand
        })
    }
    componentDidMount() {
      if( this.props.onRef)this.props.onRef(this);
    };
    render() {
        const { list, title, size, styleName,expand} = this.props;
        const { visible, current, expandPage }=this.state;
        return (<div className={styleName?styleName:'wrapPicturePreview'}>
            {title&&<div className={'titlePicturePreview'}>
                <div className={'title'}>
                    <span>{title}</span>
                {!expand&&<span onClick={()=>this.setExpand(!expandPage)}>{expandPage?Lang({id:'ShouQi',default: '收起'}):Lang({id:'ZhanKai',default: '展开'})}</span>}
                </div>
            </div>}
            {expandPage&&<div className={'mainPicturePreview'} style={{ height:size+'px'}}>
                {list.length>0?this.getList(list,size):<div className={'picNone'}>{Lang({id:'ZanWeiShangChuan',default: '暂未上传'})}</div>}
            </div>}

            <div style={{ display: 'none' }}>
                <ImagePreviewGroup preview={{ visible, current, onVisibleChange: vis => this.setVisible(vis) }}>
                    {list.map(src=><Image src={src.fileUrl} key={src.fileId} />)}
                </ImagePreviewGroup>
            </div>
        </div>);
    }
}

export default PicturePreview;
